import AssignmentsTable from 'pages/timecards/AssignmentsTable';
import { ClassifierData } from 'types/classifiers';
import { MatterDto } from 'types/matters';

interface Props {
    matter: MatterDto;
    classifiers: Record<string, ClassifierData>;
}

const AssignmentView: React.FC<Props> = ({ matter, classifiers }) => {
    return (
        <div className="flex h-full flex-col gap-4">
            <AssignmentsTable matter={matter} classifiers={classifiers} />
        </div>
    );
};

export default AssignmentView;
